import { Controller } from '@hotwired/stimulus';

/**
 * PartitionConfirmationController
 *
 * 分割組成 確認画面で「上記口数で組成することを確認しました」のチェックボックスが
 * チェックされている時のみ、実行ボタンを有効化する。誤操作防止用。
 */
export default class extends Controller {
  static targets = ['checkbox', 'submit'];

  connect() {
    this.sync();
  }

  sync() {
    this.submitTarget.disabled = !this.checkboxTarget.checked;
  }
}
